<template>
    <v-form
        ref="form"
        v-model="isValid"
        @submit.prevent="save()">
        <v-card>
            <v-card-title>
                <span class="headline">{{ isEdit ? "Edit" : "Add" }} {{ entity.singleTitle }}</span>
            </v-card-title>

            <v-card-text>
                <app-text-field
                    ref="subjectField"
                    v-model="subject"
                    label="Subject"
                    :rules="[v => !!v || 'Subject is required']"
                    autofocus
                    validate-on-blur />
                <tag-buttons @insert-tag="insertTagToSubject" />

                <app-rich-text-area
                    ref="richTextArea"
                    v-model="content"
                    label="Content"
                    :rules="[v => !!v || 'Content is required']"
                    validate-on-blur />
                <tag-buttons @insert-tag="insertTagToContent" />

                <component
                    :is="getComponent(field)"
                    v-for="field in remainingFields"
                    :key="field.value"
                    v-model="item[field.key]"
                    :field="field"
                    validate-on-blur
                    @save="save" />
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
                <app-button
                    v-if="canDelete"
                    color="error"
                    text
                    @click="deleteItem">
                    Delete
                </app-button>
                <v-spacer />
                <app-button
                    v-if="canCancel"
                    color="secondary"
                    text
                    @click="$emit('cancel')">
                    Cancel
                </app-button>
                <app-button
                    v-if="canSave"
                    type="submit"
                    text
                    :disabled="isSaving">
                    Save
                </app-button>
            </v-card-actions>

            <v-progress-linear v-if="isSaving" indeterminate color="blue" />
        </v-card>
    </v-form>
</template>

<script>
import formMixin from "@/features/schemas/mixins/formMixin";
import TagButtons from "@/features/proposalTemplates/TagButtons.vue";
import AppRichTextArea from "@/components/richTextArea/AppRichTextArea.vue";
import textInsertionMixin from "@/mixins/textInsertionMixin";

export default {
    components: {
        AppRichTextArea,
        TagButtons
    },
    mixins:[ formMixin, textInsertionMixin ],
    types: [
        "proposalEmailTemplate"
    ],
    data() {
        return {
            subject: "",
            content: ""
        };
    },
    computed: {
        remainingFields() {
            return this.fields.filter(field =>
                field.key !== 'subject' && field.key !== 'content'
            );
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.item = JSON.parse(JSON.stringify(value));
                    this.subject = this.item.subject || "";
                    this.content = this.item.content || "";
                }
            }
        },
        subject: {
            handler(value) {
                this.item.subject = value;
            }
        },
        content: {
            handler(value) {
                this.item.content = value;
            }
        }
    },
    methods: {
        insertTagToSubject(tag) {
            this.insertTextAtCursor('subjectField', this.subject, tag, value => {
                this.subject = value;
            });
        },
        insertTagToContent(tag) {
            const richTextArea = this.$refs.richTextArea;
            if (richTextArea && typeof richTextArea.insertText === 'function') {
                richTextArea.insertText(tag);
                return;
            }

            if (this.content === undefined) this.content = '';
            this.content += tag;
        }
    }
}
</script>
